var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"player",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.id}},[_c('img',{staticStyle:{"height":"30px","width":"30px"},attrs:{"src":require("@/assets/images/player-icon.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }